import * as mutationTypes from './mutationTypes';

const mutations = {
  [mutationTypes.FETCH_ALL_TENDLC_ENUMS](state) {
    state.fetchingAllTenDlcEnums = true;
    state.errorFetchingAllTenDlcEnums = null;
  },
  [mutationTypes.DONE_FETCHING_ALL_TENDLC_ENUMS](state, { enums, apiKey }) {
    state.tenDlcEnums = enums;
    state.tenDlcEnumsAssociatedKey = apiKey;
    state.fetchingAllTenDlcEnums = false;
  },
  [mutationTypes.ERROR_FETCHING_ALL_TENDLC_ENUMS](state, { error }) {
    state.fetchingAllTenDlcEnums = false;
    state.errorFetchingAllTenDlcEnums = error;
  },
};

export default mutations;
